<template>
  <div class="controls">
    <div class="controls__header">
      <columns class="controls__button" />
      <a-badge class="controls__button" :dot="isFiltered">
        <a-button
          @click.prevent="$refs.filters.addFilter"
          type="primary"
          icon="filter"
        ></a-button>
      </a-badge>
      <entity v-if="rights.meta" class="controls__button" />
      <item v-if="rights.edit" class="controls__button" />
      <a-button
        @click.prevent="$emit('export')"
        type="primary"
        icon="download"></a-button>
    </div>
    <filters @change="handleFilter" ref="filters" />
  </div>
</template>

<script>
import Columns from './Columns/index.vue';
import Filters from './Filters/index.vue';
import Entity from './Entity/index.vue';
import Item from './Item/index.vue';

export default {
  name: 'controls',
  components: {
    Columns, Filters, Entity, Item,
  },
  data() {
    return {
      isFiltered: false,
    };
  },
  watch: {
    entity() {
      this.isFiltered = false;
    },
  },
  methods: {
    handleFilter(filter) {
      this.isFiltered = !!Object.keys(filter).length;
      this.$emit('filter', filter);
    },
  },
};
</script>

<style lang="scss" scoped>
.controls {
  margin-bottom: 16px;

  &__header {
    margin-bottom: 8px;
  }

  &__button {
    display: inline-block;
    margin-right: 8px;
  }
}
</style>
